import React from 'react';
import ReactModal from 'react-modal';
import './SimpleModal.scss';

export default class SimpleModal extends React.Component {
  static defaultProps = {
    className: 'ReactModal',
  };

  render() {
    const { className, ...props } = this.props;

    const contentBase = `${className}__content`;
    const overlayBase = `${className}__overlay`;
    const overlayClassName = {
      base: overlayBase,
      afterOpen: `${overlayBase}--after-open`,
      beforeClose: `${overlayBase}--before-close`,
    };
    const contentClassName = {
      base: contentBase,
      afterOpen: `${contentBase}--after-open`,
      beforeClose: `${contentBase}--before-close`,
    };

    return (
      <ReactModal
        className={contentClassName}
        overlayClassName={overlayClassName}
        portalClassName={className}
        closeTimeoutMS={150}
        {...props}
      />
    );
  }
}
